import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function FeaturedUpdate() {
  return <section className="py-20 md:py-28 px-4 md:px-8" data-id="element-247" data-mp="2x41962yw5v8e">
      <div className="max-w-[1400px] mx-auto" data-id="element-248" data-mp="2j5jlu6cwekr0">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="grid grid-cols-1 lg:grid-cols-5 gap-0 bg-forest text-bone overflow-hidden" data-id="element-249" data-mp="2j4rsl26rwz3w">
          <div className="lg:col-span-3 relative min-h-[320px] lg:min-h-[520px] overflow-hidden group" data-id="element-250" data-mp="2e8kws283d3zo">
            <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&q=80" alt="Líderes y lideresas en formación geográfica" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-251" data-mp="20d8p6u8u7j1c" />
            <div className="absolute top-6 left-6 bg-clay text-bone px-4 py-2 text-xs font-bold uppercase tracking-widest flex items-center gap-2" data-id="element-252" data-mp="1vfgw3wwghqvk">
              <Sparkles size={14} data-id="element-253" data-mp="2zpqxuvvh81ia" />
              El proyecto en una mirada
            </div>
          </div>

          <div className="lg:col-span-2 p-8 md:p-12 lg:p-14 flex flex-col justify-center" data-id="element-254" data-mp="3dpryca7tx6x8">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.1] mb-6" data-id="element-255" data-mp="39n564878xjzi">
              Información geográfica al servicio de los territorios y las
              comunidades
            </h2>
            <p className="text-bone/80 font-light leading-relaxed mb-4" data-id="element-256" data-mp="2gzsirvt9h855">
              El Proyecto TEFOS articula el ordenamiento del territorio, el
              Catastro Multipropósito —incluyendo su implementación en
              territorios indígenas—, los acuerdos de conservación ambiental y
              la apropiación de la información geográfica para fortalecer la
              gobernanza ambiental y territorial en Colombia. Este esfuerzo se
              apoya en la formación geográfica intercultural de la Escuela
              Intercultural de Geografía para la Vida, fundamental para la
              implementación de esta estrategia.
            </p>
            <p className="text-bone/70 font-light leading-relaxed text-sm" data-id="element-257" data-mp="axosfpb6ualb">
              Recorre esta página para conocer los avances del Catastro
              Multipropósito en territorios indígenas, los Objetos Territoriales
              Legales y su visor, los acuerdos de conservación en el Parque
              Nacional Natural Paramillo, la plataforma Colombia en Mapas, los
              diplomados virtuales en ordenamiento territorial y ambiental y la
              alianza con la Escuela Intercultural de Geografía para la Vida,
              pilares fundamentales de este esfuerzo colectivo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}